<template>
  <div class="practice-exercises">
    <div class="practice-exercises__menu">
      <Menu />
    </div>

    <div class="practice-exercises__exercises">
      <div
        :key="exercise.slug"
        v-for="exercise in visibleExercises"
        class="practice-exercises__exercise">
        <Exercise
          :exercise="exercise" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Menu from "./menu";
import Exercise from "./exercise";
import customStore from "./custom-store";
import { mapGetters } from "vuex";
import Sentry from "modules/sentry";

export default {
  name: "PracticeExercises",
  components: {
    Exercise,
    Menu
  },
  computed: {
    ...mapGetters("user", ["loggedIn", "isFreeUser"]),
    visibleExercises() {
      if (!this.filterPresent && this.isFreeUser) {
        return this.customStore.state.exercises.sort((a, b) => {
          if (a.free === b.free) {
            return a.position - b.position;
          }

          return a.free ? -1 : 1;
        }).filter(exercise => {
          return this.customStore.exerciseVisible(exercise);
        });
      }

      return this.customStore.state.exercises.filter(exercise => {
        return this.customStore.exerciseVisible(exercise);
      });
    },
    filterPresent() {
      return Object.keys(this.customStore.state.selectedFilters).length > 0;
    },
  },
  data() {
    return {
      customStore: customStore,
      activeMenu: null
    }
  },
  watch: {
    loggedIn(newValue) {
      if (newValue) {
        axios
          .get("/api/mock-interviews/exercises/solved")
          .then(response => {
            const solvedExercisesIds = response.data.solved_exercises_ids;

            this.customStore.state.exercises.forEach(exercise => {
              // https://medium.com/@miladmeidanshahi/update-array-and-object-in-vuejs-a283983fe5ba
              this.$set(exercise, "solved", solvedExercisesIds.indexOf(exercise.id) > -1)
            });
          })
      }
    }
  },
  mounted() {
    axios
      .get("/api/mock-interviews/exercises")
      .then(response => {
        const exercises = JSON.parse(response.data.exercises);

        this.customStore.setExercises(exercises);

        const $spinner = document.querySelector(".mock-interviews-exercises-page__spinner");
        if($spinner) {
          $spinner.remove();
        }
      })
      .catch(error => {
        Sentry.captureException(error)
      });
  }
}
</script>

<style lang="scss">
.practice-exercises {
  &__menu {
    display: none;

    @include breakpoint($md) {
      display: block;
      margin-bottom: $px24;
    }
  }

  &__exercise {
    &:not(:last-child) {
      margin-bottom: $px24;
    }
  }
}
</style>
